import { memo, useCallback } from 'react';

import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
  FormControlContainer,
  InputController,
  WidgetSubHeaderText,
} from '@shared/index';

import type { LoginFormParams, LoginProps } from '../model';

export const Login = memo(({ isRenderTitle = true }: LoginProps) => {
  const { t } = useTranslation();
  const {
    control,
    formState: { errors },
    clearErrors,
  } = useFormContext<LoginFormParams>();

  const handleInputChange = useCallback(() => {
    if (Object.values(errors)) {
      clearErrors();
    }
  }, [clearErrors, errors]);

  return (
    <div>
      {isRenderTitle && (
        <WidgetSubHeaderText>
          {t('LOGIN:headers.enterToPersonalAccount')}
        </WidgetSubHeaderText>
      )}
      <FormControlContainer>
        <InputController<LoginFormParams>
          control={control}
          name='phoneNumber'
          label={t('COMMON:labels.phone') || ''}
          id='phoneNumber'
          onChange={handleInputChange}
          type='tel'
          testId='login.phone'
        />
      </FormControlContainer>
      <FormControlContainer $margin={'0px 0px 16px 0px'}>
        <InputController<LoginFormParams>
          control={control}
          name='password'
          label={t('LOGIN:labels.password') || ''}
          id='password'
          onChange={handleInputChange}
          type='password'
          testId='login.password'
        />
      </FormControlContainer>
    </div>
  );
});
